module.exports = __webpack_public_path__ + "img/CA8892_F9D7DC_EBB8C0_F3C4CC-256px.6143bfc1.png";